import React, { PureComponent } from "react";
import { Metric, Error, renderTrend } from "components/Utils/Utils.js";
import clsx from "clsx";

class WorldCupTournamentAverages extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={260} />;
    }

    const COLORS = ["orange", "orange-lighter", "yellow-light", "teal-light"];

    const renderResults = (data) =>
      data.results.map((o, j) => {
        return (
          <div key={o.name + j} className="width-350 d-flex">
            <div className="pr-2 text-right width-125 d-flex align-items-center justify-content-end">
              <small className="d-inline width-100">{o.name}</small>

              <span className="ml-auto d-inline world-cup-primary-metric-gray width-100">
                {o.trend?.value && renderTrend(o.trend.value)}
              </span>
            </div>

            <div className="pr-2 width-150">
              <div
                className={clsx("progress-bar-lg cell-chart", {
                  progress: o.chart.value > 0,
                  "progress-no-value": o.chart.value === 0,
                })}
              >
                <div
                  className={clsx(`progress-bar progress-bar-${COLORS[j]}`, {
                    "progress-bar-striped": j > 0,
                  })}
                  role="progressbar"
                  style={{ width: o.chart.value + "%" }}
                  aria-valuenow="10"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>

            <div className="pl-1 mr-4 text-left width-125 d-flex align-items-center world-cup-primary-metric-gray">
              {o.metric.value > 0 && (
                <Metric {...o.metric} size={"xs"} format="0,0" />
              )}
            </div>
          </div>
        );
      });

    const renderColumns = (columns) => {
      return columns.map((o, i) => (
        <div key={i} className="py-4 world-cup-border-dash-right">
          {renderResults(o)}
        </div>
      ));
    };

    const renderRows = () =>
      data.rows.map((o, i) => {
        const highlight = o.active ? 1 : 0.2;
        return (
          <div key={i} style={{ opacity: highlight }}>
            <div className="d-flex">
              <div className="pt-4 mr-4 width-125 table-row-title">
                {o.name}
              </div>
              {renderColumns(o.columns)}
            </div>
            <div className="divider-dotted-spaced"></div>
          </div>
        );
      });

    return (
      <div className="row">
        <div className="mb-4 col-12">
          <small className="info-format">
            All values are in Thousands (000)
          </small>
        </div>

        <div className="d-inline-flex w-100">
          <div className="d-inline-block width-125"> </div>
          <div className="pb-2 d-inline-block width-350 table-header-border pl-2">
            TAD (Match Avg) <br />
            <i>From Nielsen Fasties when Actuals haven't arrived yet.</i>
          </div>
          <div className="ml-4 pb-2 d-inline-block width-350 table-header-border pl-2">
            Linear (Match Avg) <br />{" "}
            <i>From Nielsen Fasties when Actuals haven't arrived yet.</i>
          </div>
          <div className="pl-2 pb-2 d-inline-block width-350 table-header-border">
            Streaming Minutes (Match Avg)
          </div>
        </div>
        <div className="divider-dotted-spaced"></div>

        {renderRows()}
      </div>
    );
  }
}

export default WorldCupTournamentAverages;
